import {
  CarePathDefaultTemplate,
  CarePathDefaultTemplateProps,
} from 'components/templates/carePath/landing'

import { CarePathTh } from './carePathTh'
import { Taganil } from './taganil'
import { useDetectSCpage } from 'hooks/useDetectSCpage'
import { Soya } from './soya'
import { Similac } from './similac'

export const CarePathDefaultTemplateHandler = (
  props: CarePathDefaultTemplateProps,
) => {
  const { spotlight } = props
  const {
    // isNestle,
    // isCarePath,
    isCarePathKhumor,
    // isRoche,
    isSoya,
    isTaganil,
    isSimilac,
    // isNan,
  } = useDetectSCpage(spotlight?.keyID)
  return isCarePathKhumor ? (
    <CarePathTh {...props} />
  ) : isTaganil ? (
    <Taganil {...props} />
  ) : isSoya ? (
    <Soya {...props} />
  ) : isSimilac ? (
    <Similac {...props} />
  ) : (
    <CarePathDefaultTemplate
      {...props}
      // moreDataRes={moreDataRes}
      // embbedDoctorsResult={embbedDoctorsResult}
    />
  )
}
